/* Cola Feliz · comportamiento del tema
   Todo arranca leyendo atributos data-* del HTML, sin dependencias. */
(() => {
  'use strict';
  console.log('[Cola Feliz] tema v3 cargado');
  const SIN_MOV = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  /* lee un <script type="application/json"> con red de seguridad */
  function datos(contenedor, marca, porDefecto) {
    try {
      const el = contenedor.querySelector(`script[${marca}]`);
      if (!el) return porDefecto;
      const v = JSON.parse(el.textContent.trim());
      return v == null ? porDefecto : v;
    } catch (e) {
      console.warn('[Cola Feliz] no pude leer', marca, e);
      return porDefecto;
    }
  }

  /* ───────── caja de cartón en 3D ───────── */

  /* reparto en cuadrícula: las piezas nunca se solapan */
  function reparto(n) {
    const escala = n <= 2 ? 1 : n <= 3 ? .9 : .8;
    const dx = 174 * escala, dy = 176 * escala;
    const filas = n <= 3 ? [n] : n === 4 ? [2, 2] : n === 5 ? [3, 2] : n === 6 ? [3, 3] : [3, 3, n - 6];
    const base = -168 - (filas.length - 1) * dy;
    const sitios = [];
    filas.forEach((cuantos, fila) => {
      for (let i = 0; i < cuantos; i++)
        sitios.push({ x: (i - (cuantos - 1) / 2) * dx, y: base + fila * dy, escala });
    });
    return sitios;
  }

  function abre(caja, si) {
    caja.classList.toggle('abierta', si);
    $$('.pieza', caja).forEach((p, i) => setTimeout(() => {
      if (si) { p.classList.remove('apagada'); p.style.transform = p.dataset.destino; }
      else    { p.classList.add('apagada');    p.style.transform = ''; }
    }, si ? 420 + i * 110 : i * 50));
  }

  function animaCaja(caja, { autogiro = true } = {}) {
    let gY = -26, gX = -18, arrastra = false, px = 0, py = 0, recorrido = 0, abierta = false;
    if (!SIN_MOV) {
      const bucle = () => {
        if (autogiro && !arrastra && !abierta) gY += .16;
        caja.style.transform = `rotateX(${gX}deg) rotateY(${gY}deg)`;
        const contra = `rotateY(${-gY}deg) rotateX(${-gX}deg)`;
        for (const f of caja.getElementsByClassName('frente-pieza')) f.style.transform = contra;
        if (caja.isConnected) requestAnimationFrame(bucle);
      };
      requestAnimationFrame(bucle);
    }
    caja.addEventListener('pointerdown', e => {
      arrastra = true; recorrido = 0; px = e.clientX; py = e.clientY;
      caja.setPointerCapture(e.pointerId);
    });
    caja.addEventListener('pointermove', e => {
      if (!arrastra) return;
      recorrido += Math.abs(e.clientX - px) + Math.abs(e.clientY - py);
      gY += (e.clientX - px) * .4;
      gX = Math.min(25, Math.max(-55, gX - (e.clientY - py) * .28));
      px = e.clientX; py = e.clientY;
    });
    for (const ev of ['pointerup', 'pointercancel']) caja.addEventListener(ev, () => {
      if (arrastra && recorrido < 8) caja.dispatchEvent(new CustomEvent('toque'));
      arrastra = false;
    });
    return {
      get abierta() { return abierta; },
      alterna() { abierta = !abierta; abre(caja, abierta); return abierta; },
      abrir() { if (!abierta) { abierta = true; abre(caja, true); } }
    };
  }

  /* La caja ya viene dibujada en el HTML (snippet cf-caja).
     Aquí solo se coloca cada pieza y se le da movimiento. */
  function colocaPiezas(caja) {
    const piezas = $$('.pieza', caja);
    if (!piezas.length) return;
    const sitios = reparto(piezas.length);
    piezas.forEach((el, i) => {
      const s = sitios[i];
      el.dataset.destino = `translate3d(${s.x | 0}px,${s.y | 0}px,0) scale(${s.escala})`;
    });
  }

  function montaCajas() {
    $$('[data-caja3d]').forEach(escena => {
      if (escena.dataset.montada) return;
      escena.dataset.montada = '1';
      const caja = $('.caja3d', escena);
      if (!caja) { console.warn('[Cola Feliz] la escena no trae caja'); return; }
      colocaPiezas(caja);
      const pista = $('.pista', escena);
      const api = animaCaja(caja, { autogiro: escena.dataset.autogiro !== 'no' });
      if (escena.dataset.abierta === 'si') setTimeout(() => api.abrir(), 350);
      caja.addEventListener('toque', () => {
        const ab = api.alterna();
        if (pista) pista.textContent = ab
          ? (escena.dataset.pistaAbierta || '🐾 Esto lleva dentro')
          : (escena.dataset.pistaCerrada || '👆 Toca la caja');
      });
    });
  }

  /* ───────── jauría en 3D (acceso y club) ───────── */
  function montaJauria() {
    const capa = $('[data-jauria]');
    if (!capa || capa.dataset.montada) return;
    capa.dataset.montada = '1';
    const fotos = datos(capa, 'data-cf-jauria', []);
    if (!fotos.length) return;

    const ANILLOS = [
      { n: 14, radio: 1.02, alto: -0.30, vel:  0.000052, base:  74, giro: 0 },
      { n: 12, radio: 0.78, alto:  0.06, vel: -0.000068, base:  96, giro: 1.1 },
      { n:  8, radio: 0.52, alto:  0.40, vel:  0.000088, base: 124, giro: 2.3 }
    ];
    const perros = [];
    let k = 0;
    for (const a of ANILLOS) {
      for (let i = 0; i < a.n; i++) {
        const el = document.createElement('div');
        el.className = 'can';
        el.innerHTML = `<img src="${fotos[k % fotos.length]}" alt="" loading="lazy">`;
        capa.appendChild(el);
        perros.push({
          el, ...a,
          fase: a.giro + i * (Math.PI * 2 / a.n),
          bamboleo: 0.5 + (i % 5) * 0.24,
          desfase: i * 1.7,
          tam: a.base * (0.86 + (i % 4) * 0.11)
        });
        k++;
      }
    }

    let W = capa.clientWidth, H = capa.clientHeight;
    const mide = () => { W = capa.clientWidth; H = capa.clientHeight; };
    if ('ResizeObserver' in window) new ResizeObserver(mide).observe(capa);
    addEventListener('resize', mide, { passive: true });

    const raton = { x: 0, y: 0, sx: 0, sy: 0 };
    (capa.parentElement || capa).addEventListener('pointermove', e => {
      const r = capa.getBoundingClientRect();
      raton.x = ((e.clientX - r.left) / r.width  - .5) * 2;
      raton.y = ((e.clientY - r.top)  / r.height - .5) * 2;
    }, { passive: true });

    const pinta = t => {
      raton.sx += (raton.x - raton.sx) * .06;
      raton.sy += (raton.y - raton.sy) * .06;
      const cx = W / 2, cy = H * 0.5;
      const RX = Math.max(W * 0.44, 300), RY = Math.min(H * 0.16, 110);
      for (const p of perros) {
        const a = t * p.vel + p.fase;
        const prof = Math.cos(a);
        const kk = (prof + 1) / 2;
        const tam = p.tam * (0.34 + kk * 1.06);
        const x = cx + Math.sin(a) * RX * p.radio + raton.sx * 34 * kk;
        const y = cy + H * p.alto + Math.cos(a) * RY
                + Math.sin(t * 0.00055 * p.bamboleo + p.desfase) * 14
                + raton.sy * 22 * kk;
        const s = p.el.style;
        s.width = tam.toFixed(1) + 'px';
        s.transform = `translate3d(${(x - tam / 2).toFixed(1)}px,${(y - tam / 2).toFixed(1)}px,0)`
                    + ` rotate(${(Math.sin(a * 1.4 + p.desfase) * 5).toFixed(2)}deg)`;
        s.opacity = (0.18 + kk * 0.82).toFixed(3);
        s.filter  = `blur(${((1 - kk) * 3.2).toFixed(2)}px) saturate(${(0.55 + kk * 0.5).toFixed(2)})`;
        s.zIndex  = String(100 + Math.round(prof * 60));
      }
    };
    mide();
    if (SIN_MOV) { pinta(0); return; }
    const bucle = ts => { if (!capa.isConnected) return; pinta(ts); requestAnimationFrame(bucle); };
    requestAnimationFrame(bucle);
  }

  /* ───────── fondo que cambia al bajar ───────── */
  function montaFondo() {
    const capas = $$('#cf-capas .capa-tema');
    const chip = $('#cf-tema-chip');
    const rastros = [$('#cf-rastro-izq'), $('#cf-rastro-der')].filter(Boolean);
    if (!capas.length) return;
    const TEMAS = ['🐾 Cachorro en casa', '🌳 Paseo por el parque', '🌊 Día de playa',
                   '🎉 Hora de la fiesta', '🛋️ Siesta en el sofá'];
    const HUELLA = '<svg viewBox="0 0 100 100"><ellipse cx="26" cy="30" rx="11" ry="15"/><ellipse cx="46" cy="20" rx="11" ry="16"/><ellipse cx="68" cy="26" rx="11" ry="15"/><ellipse cx="82" cy="46" rx="10" ry="13"/><path d="M50 44c16 0 27 13 27 25s-12 15-27 15-27-3-27-15 11-25 27-25z"/></svg>';
    rastros.forEach(r => r.innerHTML = HUELLA.repeat(12));
    const pisadas = rastros.map(r => [...r.children]);
    let ultimo = -1, pendiente = false, previo = 0, sube = false;

    const pinta = () => {
      pendiente = false;
      const alto = document.documentElement.scrollHeight - innerHeight;
      const largo = alto > 1200;
      document.body.classList.toggle('pagina-corta', !largo);
      if (!largo) {
        capas.forEach((c, i) => c.style.opacity = i === 0 ? '1' : '0');
        if (chip) chip.textContent = TEMAS[0];
        ultimo = 0;
        return;
      }
      const p = Math.min(1, Math.max(0, scrollY / alto));
      if (Math.abs(scrollY - previo) > 4) { sube = scrollY < previo; previo = scrollY; }
      const pos = p * (capas.length - 1);
      capas.forEach((c, i) => c.style.opacity = Math.max(0, 1 - Math.abs(i - pos)).toFixed(3));
      const idx = Math.round(pos);
      if (idx !== ultimo && chip) {
        ultimo = idx; chip.textContent = TEMAS[idx];
        chip.style.scale = '1.12'; setTimeout(() => chip.style.scale = '', 220);
      }
      rastros.forEach(r => r.classList.toggle('sube', sube));
      pisadas.forEach(lista => lista.forEach((h, i) => h.classList.toggle('on', p * lista.length >= i)));
    };
    addEventListener('scroll', () => { if (!pendiente) { pendiente = true; requestAnimationFrame(pinta); } }, { passive: true });
    addEventListener('resize', pinta, { passive: true });
    pinta();
  }

  /* ───────── aparición al hacer scroll ───────── */
  function montaRevelado() {
    const items = $$('.cf .revela:not(.visible)');
    if (!items.length) return;
    if (SIN_MOV || !('IntersectionObserver' in window)) {
      items.forEach(i => i.classList.add('visible'));
      return;
    }
    const obs = new IntersectionObserver(es => es.forEach((e, i) => {
      if (!e.isIntersecting) return;
      setTimeout(() => e.target.classList.add('visible'), i * 80);
      obs.unobserve(e.target);
    }), { threshold: .14 });
    items.forEach(i => obs.observe(i));
  }

  /* ───────── inclinación 3D de las tarjetas ───────── */
  function montaInclinacion() {
    if (SIN_MOV || matchMedia('(pointer: coarse)').matches) return;
    $$('.cf .tarjeta:not([data-inclina])').forEach(t => {
      t.dataset.inclina = '1';
      let r = null;
      t.addEventListener('mouseenter', () => r = t.getBoundingClientRect());
      t.addEventListener('mousemove', e => {
        if (!r) return;
        const x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        t.style.transform = `perspective(950px) rotateY(${x * 11}deg) rotateX(${-y * 11}deg) translateY(-8px)`;
      });
      t.addEventListener('mouseleave', () => { r = null; t.style.transform = ''; });
    });
  }

  /* ───────── buscador «dime para qué es» ───────── */
  function montaBuscador() {
    $$('[data-buscador]:not([data-montado])').forEach(caja => {
      caja.dataset.montado = '1';
      const fichas = datos(caja, 'data-cf-fichas', []);
      const hueco = $('.sugerencia', caja);
      const pinta = id => {
        const c = fichas.find(f => f.id === id) || fichas[0];
        if (!c || !hueco) return;
        hueco.innerHTML =
          `<div class="puck" style="background:${c.tono}">${c.icono}</div>
           <div><h4>${c.nombre}</h4><p>${c.resumen}</p></div>
           <div class="lado"><span class="tarifa">${c.precio}</span>
             <a class="btn btn--coral" href="${c.url}">Ver la caja</a></div>`;
      };
      caja.addEventListener('click', e => {
        const b = e.target.closest('[data-motivo]');
        if (!b) return;
        $$('[data-motivo]', caja).forEach(x => x.setAttribute('aria-pressed', String(x === b)));
        pinta(b.dataset.motivo);
      });
      if (fichas.length) pinta(fichas[0].id);
    });
  }

  function arranca() {
    montaFondo();
    montaCajas();
    montaJauria();
    montaBuscador();
    montaRevelado();
    montaInclinacion();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca);
  else arranca();
  document.addEventListener('shopify:section:load', arranca);
})();


/* ─────────────────────────────────────────────────────────────────────
   La página respira al bajar.

   Dos cosas se mueven con el scroll: el fondo de huellas se queda un
   poco atrás (da profundidad, como si hubiera dos planos) y la caja de
   la portada gira despacio sobre su eje mientras lees.

   Va todo por variables CSS, así que si el navegador o el sistema piden
   menos movimiento no se engancha ni un listener.
   ───────────────────────────────────────────────────────────────────── */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const fondo = document.querySelector('.fondo');
  const escena = document.querySelector('.cf .hero .escena');
  const vesc = document.querySelector('.cf .escenario-video video');
  if (!fondo && !escena && !vesc) return;

  const tope = (v, max) => Math.max(-max, Math.min(max, v));
  let pendiente = false;

  const pinta = () => {
    const y = window.scrollY;
    if (fondo) fondo.style.setProperty('--par', tope(y * 0.055, 80).toFixed(1) + 'px');
    if (escena) escena.style.setProperty('--giro', tope(y * 0.028, 7).toFixed(2) + 'deg');
    if (vesc) {
      const r = vesc.getBoundingClientRect();
      const centro = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
      vesc.style.setProperty('--pare', tope(centro * -46, 46).toFixed(1) + 'px');
    }
    pendiente = false;
  };

  window.addEventListener('scroll', () => {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(pinta);
  }, { passive: true });

  pinta();
})();

/* Si el sistema pide menos movimiento, el vídeo de portada no se lanza
   solo: se queda en su primer fotograma con sus mandos. */
(() => {
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('video.hero-video').forEach(v => {
    v.autoplay = false; v.loop = false; v.controls = true;
    v.pause();
  });
})();


/* ─────────────────────────────────────────────────────────────────────
   El guion de la mascota.

   Entra andando por la izquierda alternando dos posturas —eso es lo que
   hace que ande y no que resbale—, llega hasta la caja 3D y la toca con
   el morro. La caja se abre de verdad: se dispara el mismo evento que
   si la tocaras tú. Se sienta a mirarla, y luego se aparta a la derecha,
   se tumba delante de ella y menea la cola.

   Todo lo que se ve aquí está medido sobre la caja de verdad, no puesto
   a ojo en porcentajes:

   - la HUELLA de la caja se saca uniendo sus caras, no de su rectángulo.
     El div .caja3d se queda 38 px por encima del suelo real, porque las
     caras van giradas en 3D y se salen de él. Midiendo el div el perro
     flotaba por detrás de la caja.

   - el TAMAÑO sale del ancho de esa huella, así que el perro guarda la
     misma proporción con la caja en el móvil que en el escritorio. Antes
     eran medidas fijas por media query y en pantalla pequeña el perro
     salía a la mitad de tamaño que la caja.

   - el SUELO, unos píxeles por debajo del de la caja: el perro pisa más
     cerca del espectador, y por eso se lee que está delante de ella y no
     pegado a un lado.

   Arranca cuando la portada entra en pantalla, no al cargar. Con
   «reducir movimiento» aparece ya tumbado en su sitio.
   ───────────────────────────────────────────────────────────────────── */
(() => {
  const guia = document.querySelector('[data-guia]');
  if (!guia) return;
  const portada = guia.closest('.hero');
  if (!portada) return;

  const poses = {};
  guia.querySelectorAll('.cf-pose').forEach(i => { poses[i.dataset.pose] = i; });
  const pon = (p) => {
    if (!poses[p]) return;
    for (const k in poses) poses[k].classList.toggle('on', k === p);
  };

  /* Proporciones del dibujo, medidas sobre el lienzo de 360×240 en el que
     se montaron las cinco posturas. Si se rehacen los recortes hay que
     volver a sacarlas, o el perro dejará de tocar la caja donde debe. */
  const MORRO = 0.844;   // dónde cae la punta del hocico, a lo ancho
  const LARGO = 0.756;   // lo que ocupa el perro de pie, a lo ancho
  const ASOMA = 20;      // px de rabo que se le permiten fuera por la izquierda

  const sitios = { entra: 0, caja: 0, esquina: 0, suelo: 2 };
  let ancho = 200;

  /* La caja son varias caras giradas; su div no las contiene. */
  function huella(caja, hr) {
    let l = Infinity, t = Infinity, r = -Infinity, b = -Infinity;
    const mete = (el) => {
      const q = el.getBoundingClientRect();
      if (!q.width && !q.height) return;
      l = Math.min(l, q.left); t = Math.min(t, q.top);
      r = Math.max(r, q.right); b = Math.max(b, q.bottom);
    };
    mete(caja);
    caja.querySelectorAll('.cara').forEach(mete);
    return { x: l - hr.left, y: t - hr.top, w: r - l, abajo: b - hr.top };
  }

  function mide() {
    const hr = portada.getBoundingClientRect();
    const caja = portada.querySelector('.caja3d');

    if (caja) {
      const c = huella(caja, hr);
      /* El morro se queda un pelo ANTES del borde de la caja, no dentro.
         Antes entraba un 5 % y, como el perro se pinta por encima de la
         caja, el hocico y las patas delanteras se fundían con su cara
         oscura: Lucía lo veía «tapado». El empujón (.empuja, 3°) ya lo
         acerca esos 4 px, así que se lee que la toca sin meterse en ella. */
      const meta = c.x - 4;
      /* grande, pero no tanto que el rabo se salga de la pantalla
         cuando llegue a la caja */
      ancho = Math.max(140, Math.min(c.w * 1.06, (meta + ASOMA) / LARGO));
      sitios.caja = Math.round(meta - MORRO * ancho);
      sitios.suelo = Math.max(0, Math.round(hr.height - c.abajo - ancho * 0.07));
    } else {
      ancho = Math.max(140, Math.min(hr.width * 0.2, 260));
      sitios.caja = Math.round(hr.width * 0.5);
      sitios.suelo = 2;
    }
    ancho = Math.round(ancho);
    /* Entra desde fuera de la PANTALLA, no desde el borde del hero: en
       una pantalla ancha el hero empieza a 250 px del borde y, medido
       contra él, el perro «escondido» se veía entero, plantado a la
       izquierda, hasta que echaba a andar. */
    sitios.entra = -Math.round(hr.left + ancho);
    /* Su sitio final es el borde DERECHO de la pantalla, no el del hero.
       El hero vive dentro de un .wrap de 1220 px: en una pantalla ancha
       «la esquina del hero» caía encima de la caja y la pista le tapaba
       el morro y las patas. Se mide contra la ventana y se pasa a
       coordenadas del hero, que es a lo que se refiere `left`. */
    const bordePantalla = document.documentElement.clientWidth - hr.left;
    sitios.esquina = Math.max(sitios.caja, Math.round(bordePantalla - ancho - 10));
    guia.style.setProperty('--guia-ancho', ancho + 'px');
    guia.style.setProperty('--guia-suelo', sitios.suelo + 'px');
  }

  let acabado = false;
  let destino = 'entra';   // a qué sitio va (o en cuál está) ahora mismo
  const ve = (donde, segundos) => {
    destino = donde;
    guia.style.setProperty('--guia-paso', segundos + 's');
    guia.style.setProperty('--guia-x', sitios[donde] + 'px');
  };

  mide();
  guia.style.setProperty('--guia-x', sitios.entra + 'px');

  /* Si la ventana cambia (zoom del navegador, girar el móvil, abrir las
     herramientas), se vuelve a medir y el perro sigue hacia donde iba,
     pero con las medidas nuevas. Antes solo se corregía cuando ya estaba
     tumbado: si el cambio le pillaba de camino a la esquina, seguía hacia
     la esquina VIEJA y se quedaba medio fuera de la pantalla. */
  addEventListener('resize', () => {
    mide();
    guia.style.setProperty('--guia-paso', acabado ? '0s' : '.6s');
    guia.style.setProperty('--guia-x', sitios[destino] + 'px');
  }, { passive: true });

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    guia.style.transition = 'none';
    destino = 'esquina';
    guia.style.setProperty('--guia-x', sitios.esquina + 'px');
    pon(poses.tumbado ? 'tumbado' : 'quieto');
    if (poses.tumbado) guia.classList.add('cola');
    acabado = true;
    return;
  }

  const luego = (ms, fn) => setTimeout(fn, ms);
  let paso = null;
  const andando = (si) => {
    clearInterval(paso);
    /* la clase la usa el CSS para el rebote del paso: alternar las dos
       posturas sobre una linea recta se lee como que resbala */
    guia.classList.toggle('andando', !!si);
    if (!si) { pon('quieto'); return; }
    let alterna = false;
    paso = setInterval(() => { alterna = !alterna; pon(alterna ? 'anda' : 'quieto'); }, 150);
  };

  const arranca = () => {
    mide();
    andando(true);
    requestAnimationFrame(() => ve('caja', 2.4));

    luego(2400, () => { andando(false); guia.classList.add('empuja'); });

    luego(2820, () => {
      const caja = portada.querySelector('.caja3d');
      if (caja) caja.dispatchEvent(new CustomEvent('toque'));
    });

    luego(3150, () => { guia.classList.remove('empuja'); pon('sienta'); });

    /* se lo mira un momento y se aparta a su sitio */
    luego(4600, () => { andando(true); ve('esquina', 1.4); });

    luego(6000, () => {
      andando(false);
      pon('tumbado');
      guia.classList.add('cola');
      acabado = true;
    });
  };

  const ojo = new IntersectionObserver((entradas) => {
    if (!entradas.some(e => e.isIntersecting)) return;
    ojo.disconnect();
    luego(450, arranca);
  }, { threshold: 0.2 });
  ojo.observe(portada);
})();
